import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AddonService {

  constructor(private http: HttpClient) { }

  getAllAddons(data: any): Observable<any> {
    return this.http.post(environment.getAllAddons, data);
  }

  createAddon(data: any): Observable<any> {
    return this.http.post(environment.createAddon, data);
  }

  updateAddon(data: any): Observable<any> {
    return this.http.post(environment.updateAddon, data);
  }

  deleteAddon(data: any): Observable<any> {
    return this.http.post(environment.deleteAddon, data);
  }

  assignAddonToClient(data: any): Observable<any> {
    return this.http.post(environment.createAddonSubscription, data);
  }

   updateAddonToClient(data: any): Observable<any> {
    return this.http.post(environment.updateAddonSubscription, data);
  }

    removeAddonToClient(data: any): Observable<any> {
    return this.http.post(environment.deleteAddonSubscription, data);
  }

  getClientAddons(data: any): Observable<any> {
    return this.http.post(environment.getClientAddons, data);
  }

  getAllPackageAddon(data: any): Observable<any> {
    return this.http.post(environment.getAllPackageAddon, data);
  }

  createPackageAddon(data: any): Observable<any> {
    return this.http.post(environment.createPackageAddon, data);
  }

  updatePackageAddon(data: any): Observable<any> {
    return this.http.post(environment.updatePackageAddon, data);
  }
  proformaAddonInvoice(data: any): Observable<any> {
    return this.http.post(environment.proformaAddonInvoice, data);
  }
}
